<template>
  <div>
    <div class="modal show fade modal text-left " style="display: block;" v-if="show">
      <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">
              Details
            </h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="validate-form mt-2">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label for="account-name">Risk Score</label>
                    <input type="text" class="form-control" disabled v-model="riskScore"/>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 ">
                  <div class="form-group">
                    <label for="account-des">Description</label>
                    <textarea
                        type="text"
                        v-model="description"
                        class="form-control"
                        disabled
                        rows="10"
                    />
                  </div>
                </div>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  props: ['show', 'row', 'index'],
  mounted() {

  },
  data() {
    return {
      description: '',
      riskScore: '',
    };
  },
  methods: {},
  watch: {
    show(val) {
      if (val) {
        this.description = this.row?.discription
        this.riskScore = this.row?.transactionRiskScore
      } else {
        this.$nextTick(() => {
          this.description = ''
          this.riskScore = ''
        })
      }

    },
  }
};
</script>

<style scoped>
.modal {
  display: block !important;
  /* I added this to see the modal, you don't need this */
}

/* Important part */
.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  height: 70vh;
  overflow-y: auto;
}
</style>
